// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"d_N","svgDefs":"d_O","canvas":"d_P"};